import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DocumentiService } from 'src/app/core/documenti.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule
  ],
  selector: 'app-reindex',
  template: `
  <div class="card card-w-title">
    <h1>Reindicizzazione documenti</h1>
    <p>ID documento di partenza <input pInputText type="number" [(ngModel)]="fromDocumentId" placeholder="ID documento di partenza" /></p>
    <p>Numero di documenti per ciclo <input pInputText type="number" [(ngModel)]="takeValue" placeholder="Numero di documenti per ciclo" /></p>
    <button pButton (click)="reindexDocuments()">Avvia reindicizzazione</button>
    <p>{{ statusMessage() }}</p>
  </div>
  `
})

export class ReindexComponent implements OnInit {
  private readonly documentiService = inject(DocumentiService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  takeValue: number = 100;
  fromDocumentId: number = 0;
  statusMessage = signal<string>('');

  ngOnInit() {
    this.fromDocumentId = Number(this.route.snapshot.queryParamMap.get('fromDocumentId')) || 0;
    this.takeValue = Number(this.route.snapshot.queryParamMap.get('takeValue')) || this.takeValue;
    if (this.fromDocumentId) {
      this.reindexDocuments();
    }
  }

  reindexDocuments() {
    this.documentiService.reindexAllDocuments(this.fromDocumentId, this.takeValue).subscribe({
      next: (result) => {
        if (result.length > 0) {
          const fromDocumentId = result[result.length - 1];
          this.navigateWithParams(fromDocumentId, this.takeValue);
        } else {
          this.navigateWithParams();
        }
      },
      error: (err) => {
        this.statusMessage.set('Errore durante la reindicizzazione: ' + err.message);
      }
    });
  }

  private navigateWithParams(fromDocumentId?: number, takeValue?: number) {
    const queryParams: Params = {};
    if (fromDocumentId !== undefined) queryParams.fromDocumentId = fromDocumentId;
    if (takeValue !== undefined) queryParams.takeValue = takeValue;

    const queryParamsHandling = fromDocumentId !== undefined ? 'merge' : 'replace';
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([], {
        queryParams,
        queryParamsHandling,
        relativeTo: this.route
      });
    });
  }
}
